import { InformationsPreAssurabilite } from "../../../models";
import { Question as modelQuestion } from "../../../models/question";
import { DsdColumn } from "../../DSD/DsdColumn";
import { DsdGrid } from "../../DSD/DsdGrid";
import { DsdRow } from "../../DSD/DsdRow";
import InstructionQuestionnaire from "./InstructionQuestionnaire";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import React from "react";
import "./assure.css";
import Question from "./Question";
import i18n from "../../../resources/I18n";
import { getMetaTagContent } from "../../../scripts/getMetaTag";
import { useNavigate } from "react-router";
import { INavigationParcours } from "../../../util/Navigation";
import { useCybermetrieAMCContext } from "../../utils/CybermetrieAMCContext";
import { CybermetriesAMC } from "../../../util/CybermetrieAMC";

interface IAssureProps {
  questions: modelQuestion[];
  informationsPreAssurabilite?: InformationsPreAssurabilite;
  idAssure: string;
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

export default function Assure(props: Readonly<IAssureProps>) {
  let cybermetrieParams = useCybermetrieAMCContext();
  const navigate = useNavigate();

  function getNomAssure() {
    const assures = props.informationsPreAssurabilite?.assures;
    const idAssure = props.idAssure;
    const assure = assures?.find((a: any) => a.id === idAssure);
    if (assure) {
      const prenom = (assure.prenom ?? "").toString();
      const nom = (assure.nom ?? "").toString();
      return `${prenom} ${nom}`.trim().toUpperCase();
    }
    return "";
  }

  function ObtenirResultatQuestionnaire() {
    const info = props.informationsPreAssurabilite;
    return info?.decision || info?.exigence;
  }

  const onClickBoutonModifier = () => {
    CybermetriesAMC.EnvoieModifierQuestionsAMC(cybermetrieParams);
    const isApp = getMetaTagContent("oel-is-app") ?? false;
    navigate(
      `/amc/${props.parcours}/?idSouscription=${props.cookieParcoursAssurance.idSouscription}&idAssure=${props.cookieParcoursAssurance.idAssure}&langue=${props.cookieParcoursAssurance.langue}&idCallback=${props.cookieParcoursAssurance.idCallback}&isApp=${isApp}`
    );
  };

  const mapperQuestions = props?.questions?.map((question) => {
    const localNodeRef = React.createRef<HTMLDivElement>();
    return (
      <CSSTransition nodeRef={localNodeRef} key={question.id} timeout={100} classNames="question-transition-amc">
        <div ref={localNodeRef}>
          <Question question={question} />
        </div>
      </CSSTransition>
    );
  });

  return (
    <dsd-container horizontal-scroll-items={true} padding="md">
      <DsdGrid>
        <DsdRow>
          <DsdColumn col="12" mdCol="12">
            <h3>{getNomAssure()}</h3>
            <div className="instruction-questionnaire" data-testid="instruction-questionnaire">
              <InstructionQuestionnaire verdict={ObtenirResultatQuestionnaire()} />
            </div>
            <h4>{i18n.t("amc-validation:reponses-au-questionnaire")}</h4>
          </DsdColumn>
          <DsdColumn>
            <TransitionGroup>{mapperQuestions}</TransitionGroup>
          </DsdColumn>
          <DsdColumn>
            <dsd-button variant="compact" className="bouton-modifier" data-testid="bouton-modifier" onClick={onClickBoutonModifier}>
              {i18n.t("amc-validation:bouton-modifier")}
              <span data-testid="bouton-modifier-accessibilite" className="dsd-sr-only">
                {i18n.t("amc-validation:bouton-modifier-accessibilite")}
              </span>
            </dsd-button>
          </DsdColumn>
        </DsdRow>
      </DsdGrid>
    </dsd-container>
  );
}
